import React, { FC } from "react";

import {
    Carousel,
    GoogleBusinessProfile,
    MockBrowserForm,
    OnboardingAside,
    OnboardingContent,
    PrimaryAlternateControl,
} from "@xapp/components";
import { buildDefaultFormTheme } from "utils/generateFormWidgetInput";

import { OnboardingProps } from "../../models";

import style from "./ClaimAgentStep.module.scss";

export interface ClaimAgentStepProps {
    /**
     * Optional aside content
     */
    aside?: React.ReactNode;
    /**
     * Props with place to confirm
     */
    onboarding: OnboardingProps;
    /**
     *
     * @param props
     */
    onClaim(props: OnboardingProps): void;
}

export const ClaimAgentStep: FC<ClaimAgentStepProps> = (props) => {
    const { aside, onboarding: value, onClaim } = props;

    const formTheme = buildDefaultFormTheme(value?.primaryColor);

    const headerColor = formTheme.standAlone.header.backgroundColor;
    const middleColor = formTheme.standAlone.backgroundColor;
    const footerColor = "#282c34";

    const logo = value?.logo;
    const name = value?.name;

    const showProfile = !!value.place;

    return (
        <>
            {aside && <OnboardingAside>{aside}</OnboardingAside>}

            <OnboardingContent>
                {showProfile ? (
                    <Carousel interval={3000} showTransition={true} transitionElement="👉" transitionSpeed={1.0}>
                        <div className={style.carouselItem}>
                            <GoogleBusinessProfile
                                loading={!value?.place}
                                place={value?.place}
                                showBookOnline={true}
                                styles={{ razzleDazzle: true }}
                            />
                            <p style={{ display: "block" }} className={style.descriptionText}>
                                Add a Book Online button to your Google Business Profile
                            </p>
                        </div>
                        <>
                            <MockBrowserForm
                                headerColor={headerColor}
                                middleColor={middleColor}
                                footerColor={footerColor}
                                browserFrameColor={footerColor}
                                logoUrl={logo}
                                businessName={name}
                                browserUrl={"//sche.dule.pro"}
                                type={"calendar"}
                            />
                            <p className={style.descriptionText}>
                                Install your agent on your website or leverage our customizable booking page
                            </p>
                        </>
                    </Carousel>
                ) : (
                    <>
                        <MockBrowserForm
                            headerColor={headerColor}
                            middleColor={middleColor}
                            footerColor={footerColor}
                            browserFrameColor={footerColor}
                            logoUrl={logo}
                            businessName={name}
                            browserUrl={"//sche.dule.pro"}
                        />
                        <p className={style.descriptionText}>
                            Install your agent on your website or leverage our customizable booking page
                        </p>
                    </>
                )}

                <PrimaryAlternateControl labels={{ primary: "Claim Agent" }} onPrimary={onClaim.bind(null, value)} />
            </OnboardingContent>
        </>
    );
};
